"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const toMarkdown = (element, _context) => {
    var _a, _b;
    const label = ((_a = element.value) === null || _a === void 0 ? void 0 : _a.linkLabel) || 'Link';
    const url = ((_b = element.value) === null || _b === void 0 ? void 0 : _b.linkURL) || '';
    if (!url) {
        return label;
    }
    return `[${label}](${url})`;
};
exports.toMarkdown = toMarkdown;
